var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Select } from '@web/components/ui/Form/Select';
import { classNames } from '@web/utility';
function Tabs(_a) {
    var _b;
    var active = _a.active, tabs = _a.tabs, _c = _a.onChange, onChange = _c === void 0 ? function () { return null; } : _c;
    var activeTab = tabs.find(function (tab) { return tab.id === active; });
    var options = tabs.map(function (tab) { return ({
        id: tab.id,
        name: tab.name
    }); });
    var selectedOption = options.find(function (option) { return option.id === active; }) || options[0];
    return (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ className: "mb-4 border-b border-gray-200 " }, { children: [_jsx("div", __assign({ className: "sm:hidden" }, { children: _jsx(Select, { onChange: function (newValue) {
                                if (!newValue.id)
                                    return;
                                onChange(newValue.id.toString());
                            }, selected: selectedOption, options: options }) })), _jsxs("div", __assign({ className: "flex flex-col lg:flex-row justify-between items-center" }, { children: [_jsx("nav", __assign({ className: "hidden sm:flex flex-wrap mb-4 lg:mb-0", "aria-label": "Tabs" }, { children: tabs.map(function (tab) { return (_jsx("div", __assign({ className: classNames(tab.id === active
                                        ? 'border-b-2 border-indigo-500 text-indigo-600'
                                        : 'text-gray-500 hover:text-gray-700', 'px-3 py-4 font-medium text-sm cursor-pointer mr-2'), "aria-current": tab.name === active ? 'page' : undefined, onClick: function () {
                                        if (tab.id === active)
                                            return;
                                        onChange(tab.id);
                                    } }, { children: _jsxs("div", __assign({ className: "flex flex-center items-end gap-1" }, { children: [_jsx("div", __assign({ style: { paddingTop: '1.5px' }, className: "inline-block w-5 mr-1" }, { children: tab.icon })), _jsx("span", { children: tab.name })] })) }), tab.name)); }) })), _jsx("div", __assign({ className: "m-4 sm:m-2 lg:self-start min-w-[100px]" }, { children: (_b = activeTab === null || activeTab === void 0 ? void 0 : activeTab.rightContent) !== null && _b !== void 0 ? _b : null }))] }))] })), _jsx("div", { children: activeTab && _jsx(activeTab.Component, {}) })] }));
}
export default Tabs;
